export const PAGE_TYPES = {
  BODY: 'body',
  HEALTH: 'health',
  MIND: 'mind',
  LIFE: 'life',
  SKIN: 'skin',
  ABOUT: 'about',
  POLICY: 'policy',
  TERMS: 'terms',
};

export const DNA_ROUTE_TYPES = {
  HOME: 'dna-home',
  LOGIN: 'dna-login',
  ELEMENT: 'dna-element',
  PILLAR: 'dna-element',
  GCI_REPORT: 'dna-gci-report',
  PROFILE: 'dna-profile',
  INTAKE_TEMPLATE: 'dna-intake-template',
  PREFERENCE: 'dna-preference',
  PRACTITIONER: 'dna-practitioner',
  CUSTOM_SUPPLEMENT: 'dna-custom-supplement',
  ORDER_TESTS: 'dna-order-tests',
  PROTOCOL: 'dna-protocol',
  PROGRESS: 'dna-progress',
  SOURCES: 'dna-sources',
  MEALS: 'dna-meals',
  ADMIN: 'dna-admin',
  ADMIN_SOURCE_REVIEW: 'dna-admin-source-review',
  ADMIN_GENETICS_AUDIT: 'dna-admin-genetics-audit',
  ADMIN_INTAKE_AUDIT: 'dna-admin-intake-audit',
  ADMIN_TRACE_AUDIT: 'dna-admin-trace-audit',
};

export const INTERNAL_ROUTES = [
  { path: '/', label: 'Home' },
  { path: '/health', label: 'Health', type: PAGE_TYPES.HEALTH },
  { path: '/mind', label: 'Mind', type: PAGE_TYPES.MIND },
  { path: '/body', label: 'Body', type: PAGE_TYPES.BODY },
  { path: '/life', label: 'Life', type: PAGE_TYPES.LIFE },
  { path: '/skin', label: 'Skin', type: PAGE_TYPES.SKIN },
  { path: '/about', label: 'About', type: PAGE_TYPES.ABOUT },
  { path: '/policy', label: 'Privacy Policy', type: PAGE_TYPES.POLICY },
  { path: '/terms', label: 'Terms & Conditions', type: PAGE_TYPES.TERMS },
];

export const CONTENT_PAGE_ROUTES = INTERNAL_ROUTES.filter((route) => route.type);

export const NAV_ROUTES = INTERNAL_ROUTES.filter(
  (route) => route.label && route.path !== '/policy' && route.path !== '/terms',
);

export const BANNERLESS_PAGE_TYPES = new Set([
  PAGE_TYPES.ABOUT,
  PAGE_TYPES.POLICY,
  PAGE_TYPES.TERMS,
]);

export const DNA_APP_BASE_PATH = '/dna';

export const DNA_APP_ROUTES = [
  { path: DNA_APP_BASE_PATH, label: 'DNA Dashboard', type: DNA_ROUTE_TYPES.HOME },
  { path: `${DNA_APP_BASE_PATH}/login`, label: 'DNA Login', type: DNA_ROUTE_TYPES.LOGIN },
  { path: `${DNA_APP_BASE_PATH}/elements/:element`, label: 'DNA Element', type: DNA_ROUTE_TYPES.ELEMENT },
  { path: `${DNA_APP_BASE_PATH}/pillars/:pillar`, label: 'DNA Element', type: DNA_ROUTE_TYPES.ELEMENT },
  { path: `${DNA_APP_BASE_PATH}/gci-report`, label: 'DNA GCI Report', type: DNA_ROUTE_TYPES.GCI_REPORT },
  { path: `${DNA_APP_BASE_PATH}/profile`, label: 'DNA Patient Profile', type: DNA_ROUTE_TYPES.PROFILE },
  { path: `${DNA_APP_BASE_PATH}/sources/intake/:element`, label: 'DNA Intake Template', type: DNA_ROUTE_TYPES.INTAKE_TEMPLATE },
  { path: `${DNA_APP_BASE_PATH}/preferences`, label: 'DNA Personal Inputs', type: DNA_ROUTE_TYPES.PREFERENCE },
  { path: `${DNA_APP_BASE_PATH}/protocol`, label: 'DNA Protocol', type: DNA_ROUTE_TYPES.PROTOCOL },
  { path: `${DNA_APP_BASE_PATH}/progress`, label: 'DNA Progress', type: DNA_ROUTE_TYPES.PROGRESS },
  { path: `${DNA_APP_BASE_PATH}/sources`, label: 'DNA Sources', type: DNA_ROUTE_TYPES.SOURCES },
  { path: `${DNA_APP_BASE_PATH}/meals`, label: 'DNA Meals', type: DNA_ROUTE_TYPES.MEALS },
  { path: `${DNA_APP_BASE_PATH}/admin`, label: 'DNA Admin', type: DNA_ROUTE_TYPES.ADMIN },
  { path: `${DNA_APP_BASE_PATH}/admin/source-review`, label: 'DNA Admin Source Review', type: DNA_ROUTE_TYPES.ADMIN_SOURCE_REVIEW },
  { path: `${DNA_APP_BASE_PATH}/admin/genetics-audit`, label: 'DNA Admin Genetics Audit', type: DNA_ROUTE_TYPES.ADMIN_GENETICS_AUDIT },
  { path: `${DNA_APP_BASE_PATH}/admin/intake-audit`, label: 'DNA Admin Intake Audit', type: DNA_ROUTE_TYPES.ADMIN_INTAKE_AUDIT },
  { path: `${DNA_APP_BASE_PATH}/admin/trace-audit`, label: 'DNA Admin Trace Audit', type: DNA_ROUTE_TYPES.ADMIN_TRACE_AUDIT },
];
